var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "addPage" },
    [
      _c("div", { staticClass: "addPage_header" }, [
        _c("div", { staticClass: "goBackBtn" }, [
          _c("i", {
            staticClass: "el-icon-arrow-left",
            staticStyle: {
              "margin-right": "17px",
              "line-height": "17px",
              "font-size": "17px",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("closePage")
              },
            },
          }),
          _c(
            "span",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("closePage")
                },
              },
            },
            [_vm._v("创建私有助手")]
          ),
          _vm.form.isPrivate
            ? _c("div", { staticClass: "isPrivateBtn" }, [
                _c("img", {
                  staticClass: "rightsItemIcon",
                  attrs: { src: require("@/assets/image/aigc/lock_c.png") },
                }),
                _vm._v(" 私密 "),
              ])
            : _c("div", { staticClass: "isPrivateBtn" }, [
                _c("img", {
                  staticClass: "rightsItemIcon",
                  attrs: { src: require("@/assets/image/aigc/global_c.png") },
                }),
                _vm._v(" 公开 "),
              ]),
        ]),
        _c(
          "div",
          { staticClass: "publicbtn", on: { click: _vm.onhandlePublic } },
          [
            _vm.loading
              ? _c("i", { staticClass: "el-icon-loading" })
              : _vm._e(),
            _vm._v(" 发布 "),
          ]
        ),
      ]),
      _c("div", { staticClass: "addPage_content" }, [
        _c(
          "div",
          { staticClass: "addPage_content_form" },
          [
            _c(
              "div",
              { staticClass: "addPage_avatar" },
              [
                _c("avatarCropper", {
                  model: {
                    value: _vm.form.icon,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "icon", $$v)
                    },
                    expression: "form.icon",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.form,
                  rules: _vm.rules,
                  "label-position": "top",
                  "label-width": "auto",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "助手名称", prop: "title" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "747px" },
                      attrs: {
                        placeholder: "请输入内容",
                        maxlength: "20",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "title", $$v)
                        },
                        expression: "form.title",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "功能描述", prop: "describe" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "747px" },
                      attrs: {
                        placeholder: "请输入功能描述，简要介绍助手功能",
                        maxlength: "50",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.describe,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "describe", $$v)
                        },
                        expression: "form.describe",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "助手分类", prop: "categoryId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "747px" },
                        attrs: { placeholder: "请选择助手分类" },
                        model: {
                          value: _vm.form.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "categoryId", $$v)
                          },
                          expression: "form.categoryId",
                        },
                      },
                      [
                        _vm._l(_vm.categoryList, function (item) {
                          return [
                            _c("el-option", {
                              key: item.categoryId,
                              attrs: {
                                label: item.name,
                                value: item.categoryId,
                              },
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "提示词", prop: "content" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "747px" },
                      attrs: {
                        type: "textarea",
                        autosize: { minRows: 4, maxRows: 8 },
                        resize: "none",
                        maxlength: "10000",
                        "show-word-limit": "",
                        placeholder:
                          "请输入Prompt，代表用户输入内容。eg：作为一名文案优化师，请对文章【文章内容】进行润色，要求：【文案润色要求】",
                      },
                      model: {
                        value: _vm.form.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "content", $$v)
                        },
                        expression: "form.content",
                      },
                    }),
                    _c("div", { staticClass: "formTips" }, [
                      _vm._v(
                        " 注意：使用中括号【】代表用户输入内容，最多支持10个 "
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "知识库" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("span", [_vm._v("知识库")]),
                      _c("span", { staticClass: "form_label_tips" }, [
                        _vm._v(
                          " 上传资料文档，可基于文档内容和AI助手进行聊天互动。 "
                        ),
                      ]),
                    ]),
                    _c("fileUpload", {
                      ref: "fileUpload",
                      attrs: {
                        limit: 10 - _vm.form.fileList.length,
                        accept: "*",
                        "before-video-upload": _vm.beforeVideoUpload,
                      },
                      on: { change: _vm.fileChange },
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("publicDialog", {
        attrs: { config: _vm.publicConfig, loading: _vm.loading },
        on: {
          close: function ($event) {
            return _vm.closeFn()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }